import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'Customer views a multi-asset.',
  name: 'viewed_collection',
  params: [
    {
      description: 'Collection ID',
      name: 'collection_id',
      required: true,
      type: 'string',
    },
    {
      description: 'Short URL ID',
      name: 'short_url_id',
      required: true,
      type: 'string',
    },
  ],
};

export default META;
